<template>
    <!-- Ao usar este componente, lembre-se de definir o conteiner pai deste com position: relative -->
    <div class="in-loader" :style="height.trim() != '' ? `height: ${height}` : ''">
        <Lottie :options="defaultOptions" v-on:animCreated="handleAnimation" />
    </div>
</template>

<script>
import Lottie from './Lottie';
// import Lottie from 'vue-lottie';
import * as animationData from '@/assets/spinner.json';
import { palette as paleta } from '@/functions/color/Palette';

export default {
    props: {
        height: {
            type: String,
            default: '',
        },
    },
    components: {
        Lottie,
    },
    data() {
        return {
            defaultOptions: null,
            animationSpeed: 1,
            anim: null,
        };
    },
    created() {
        let spinner = animationData.default;
        let colors = paleta.getAbcColor();

        /* [R, G, B, A]; valores entre 0 e 1 */
        spinner.layers[2].shapes[0].it[2].c.k = this.parseHexToArray(colors[0]);
        spinner.layers[1].shapes[0].it[2].c.k = this.parseHexToArray(colors[1]);
        spinner.layers[0].shapes[0].it[2].c.k = this.parseHexToArray(colors[2]);

        this.defaultOptions = {
            animationData: spinner,
        };
    },
    methods: {
        handleAnimation(anim) {
            this.anim = anim;
        },
        parseHexToArray(h) {
            let p = parseInt(h.replace('#', ''), 16);

            let r = [(p >> 16) / 255, ((p >> 8) & 0x00ff) / 255, (p & 0x0000ff) / 255, 1];

            return r;
        },
    },
};
</script>

<style lang="scss" scoped>
.in-loader {
    position: absolute;
    z-index: 8;
    // height: 100%;
    // width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border-radius: 5px;
    background: rgba($bg-color, 0.8);
}

img {
    margin-top: calc(25% - 32px);
    margin-left: calc(50% - 32px);
    animation-name: spin;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    @-ms-keyframes spin {
        from {
            -ms-transform: rotate(0deg);
        }
        to {
            -ms-transform: rotate(360deg);
        }
    }
    @-moz-keyframes spin {
        from {
            -moz-transform: rotate(0deg);
        }
        to {
            -moz-transform: rotate(360deg);
        }
    }
    @-webkit-keyframes spin {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
        }
    }
    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
}
</style>
